// extracted by mini-css-extract-plugin
module.exports = {"profileButton":"avatar_profileButton__1k4qx","spyIcon":"avatar_spyIcon__1T5gO"};